import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { getCodeVivaEligibleSubmissions } from "../../services/thesisAssignedService";

export const AssignCodeExaminerList = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await getCodeVivaEligibleSubmissions();
      setRows(res?.data || []);
    } catch (err) {
      console.error("fetch error", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const columns = [
    { field: "thesis_title", headerName: "Title", width: 220 },
    { field: "student_name", headerName: "Student Name", width: 150 },
    { field: "enrollment_number", headerName: "Enrollment No", width: 130 },
    { field: "degree_name", headerName: "Degree", width: 90 },
    { field: "program_name", headerName: "Program", width: 150 },
    { field: "report_type", headerName: "Report Type", width: 110 },
    { field: "term_type", headerName: "Submission Type", width: 130 },
    { field: "date_submitted", headerName: "Date Submitted", width: 140 },
    {
      field: "action",
      headerName: "Code Examiner",
      width: 220,
      renderCell: (params) => {
        if (!params || !params.row) return null;
        const { id, codeExaminerId, codeExaminerName } = params.row;
        return (
          <div className="cellAction">
            {codeExaminerId ? (
              <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <span>{codeExaminerName}</span>
                <Link to={`assigncodeexaminer/${id}`}>Reassign</Link>
              </div>
            ) : (
              <div className="editButton">
                <Link to={`assigncodeexaminer/${id}`}>Assign Code Examiner</Link>
              </div>
            )}
          </div>
        );
      },
    },
  ];

  if (loading) return <p>Loading…</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <span>Code Viva Eligible Submissions</span>
      </div>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row.id}
        getRowHeight={() => "auto"}
        pageSizeOptions={[5, 10]}
        initialState={{
          pagination: { paginationModel: { page: 0, pageSize: 10 } },
        }}
        autoHeight
      />
    </div>
  );
};

export default AssignCodeExaminerList;
